import {SummaryModel} from "../../../../../common/entity/summary.model";
import {PermissionsModel} from "src/app/modules/common/entity/permissions.model";
import {PrescriptionMedicineSummaryModel} from "../../../medicine/api/model/prescriptionMedicineSummary.model";

export class PrescriptionDefinitionLineSummaryModel implements SummaryModel {
    id: number;
    permissions: PermissionsModel;
    medicine: PrescriptionMedicineSummaryModel;
    quantity: string;
    turnoverCount: string;
    dosage: string;
    duration: string;
}